export default {
    name: "appFooter"
}
